<template>
    <svg xmlns="http://www.w3.org/2000/svg" 
        class="logo"
        width="228.9" 
        height="186.482" 
        viewBox="0 0 228.9 186.482"
        >
    <path fill="#000" d="M213.7 16.382v1.3c-3 1.5-13.5 8.6-31.4 21.1-18.9 14.2-28.4 23-28.4 26.4 0 2.3.8 4.5 2.4 6.2 0 .9 7.5 1.4 22.5 1.4 1.9 1.7 2.8 2.9 2.8 3.7 0 13.2-32.3 45.7-96.7 97.4v-1.2c3.4-7.3 20.9-33.4 52.6-78.1 1.1-1.9 2-3.4 2.7-4.6 1.4-2.5 1.9-5.1 1.4-7.5h-3.9c-1.8.7-2.9 1.5-3.6 2.4v.5c-.7.5-1.1 1.3-1.4 2.2-41 51.8-61.5 81.8-61.5 90.2 0 5.8 3.3 8.7 10.1 8.7 17.5 0 41.2-16.8 71.1-50.2 27.7-30.6 41.5-50.5 41.5-59.8 0-10.2-5.4-15.6-16.1-16.4l1-1c6.7-5.2 17.5-12.6 32.5-22.4 11.8-9.4 17.6-17.4 17.6-24.1 0-25.8-38.1-11.9-114.1 41.5-76.5 52.4-114.8 92.4-114.8 119.8 0 4.4.4 6.8 1.2 7.5 3.1 1.7 5.1 1.5 6-.9 37.8-69.3 106.6-124.1 206.5-164.1z"/>
    </svg>
</template>

<script>
export default {
  name: "Logo"
};
</script>
